import React from 'react';
import classNames from 'classnames';
import { Avatar } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AlyceTheme } from '@alycecom/ui';

const useStyles = makeStyles<AlyceTheme, { src: string }>({
  avatar: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundImage: props => `url('${props.src}')`,
  },
});

export interface IStyledAvatarProps {
  src: string;
  alt?: string;
  className?: string;
}

const StyledAvatar = ({ src, alt = '', className = '' }: IStyledAvatarProps): JSX.Element => {
  const classes = useStyles({ src });

  return <Avatar className={classNames('avatar-ie', classes.avatar, className)} src={src} alt={alt} />;
};

export default StyledAvatar;
